import { SyncEventType } from '../../enums/syncEventType';
import { RealtimeEvent } from './realtimeEvent';

export class EventSprintcardOpened implements RealtimeEvent {

  public readonly type = SyncEventType.SPRINTCARD_OPENED;
  public sprintId: number;
  public isNewSprint: boolean;
  public position: any;

  constructor(sprintId: number, position: any) {
    this.sprintId = sprintId;
    this.isNewSprint = (Number(this.sprintId) < 0);
    this.position = position;
  }

  getPayload(): object {
    const payload = {
      'sprintId': this.sprintId,
      'isNewSprint': this.isNewSprint,
      'position': this.position
    };
    return payload;
  }

  static fromPayload(payload: any): EventSprintcardOpened {
    return new EventSprintcardOpened(
      payload['sprintId'],
      payload['position']
    );
  }

}

